import React from 'react'

const UserRegistrationHead = () => (
    <div className="head-scene">
        <h2>Sign up for The MLC Portal</h2>
        <p>
            Fill out the form below to register as a user with The MLC. You will then be guided through an identity
            verification process. To protect our Members from fraudulent activity, we verify the identity of all new
            users before confirming registration.
        </p>
        <br />
        <p>
            Once verified, you&apos;ll receive an email with next steps to complete your account setup. From there,
            you&apos;ll answer a few questions about your role that will help us connect you with the right Hub.
        </p>
    </div>
)

export default UserRegistrationHead
